import { debounce, IconButton, InputBase, makeStyles } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles({
  searchText: {
    width: '280px',
    fontFamily: 'Lato',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19.6px',
    textAlign: 'left',
  },
  searchIcon: {
    fontFamily: 'Lato',
    fontSize: '12px',
    padding: '20px',
    color: '#10182B',
    height: '16px',
    width: '16px',
  },
});
const CustomSearchField = ({ handleSearch, placeholder = '' }) => {
  const classes = useStyles();
  return (
    <>
      <IconButton type="button" className={classes.searchIcon} aria-label="search">
        <Search />
      </IconButton>
      <InputBase
        onChange={debounce(handleSearch, 300)}
        className={classes.searchText}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search google maps' }}
      />
    </>
  );
};

export default CustomSearchField;
